import React, { useEffect, useState } from 'react';

const Navbar = () => {
  const [userData, setUserData] = useState({
    firstName: '',
    lastName: '',
    role: '',
    email: '',
  });

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setUserData({
        firstName: user.firstName || 'User', // Access firstName
        lastName: user.lastName || '',    
        role: user.role || 'Admin',
        email: user.email || 'No email provided',
      });
    }
  }, []);

  return (
    <div className="fixed right-0 w-1/2 top-0 p-6 mb-52">
      <div className="flex flex-col items-end">
        <h4 className="text-gray-800 font-bold">{userData.firstName}{userData.lastName}</h4>
        <p className="text-gray-500">{userData.role}</p>
        <p className="text-gray-400">{userData.email}</p>
      </div>
    </div>
  );
};

export default Navbar;
